import { SmartSendItemApiModel } from '~/lib/api/smartsend/types';
import { IsPackaged } from '../../../lib/helpers/IsPackaged';
import MarketplaceActionsAwaitingDispatch from './MarketplaceActionsAwaitingDispatch';
import MarketplaceActionsDispatched from './MarketplaceActionsDispatched';
import { ItemActionType } from './SetMarketplaceAction';
import { MarketplaceSupportsMarkingAsDispatched } from '../../../lib/helpers/MarketplaceSupportsMarkingAsDispatched';

interface props {
  item: SmartSendItemApiModel;
  action?: (type: ItemActionType) => void;
  size: 'small' | 'normal';
}

export default function MarketplaceActions(props: props) {
  // Need to figure out how to tie these together in the Edge
  if (props.item.Type != 'SmartSend') {
    return null;
  }

  const toggleDispatch = (isRetry: boolean) => {
    props.action && props.action(isRetry ? 'MARK-AS-DISPATCHED-RETRY' : 'MARK-AS-DISPATCHED');
  };

  const togglePackaged = () => {
    props.action && props.action(IsPackaged(props.item) ? 'MARK-AS-UNPACKAGED' : 'MARK-AS-PACKAGED');
  };

  const packaged = IsPackaged(props.item);
  const itemActions: ItemActionType[] = MarketplaceSupportsMarkingAsDispatched(props.item)
    ? ['MARK-AS-DISPATCHED', 'MARK-AS-PACKAGED']
    : ['MARK-AS-PACKAGED'];

  if (props.item.MarketplaceStatus === 'Dispatched') {
    return (
      <MarketplaceActionsDispatched
        size={props.size}
        packaged={packaged}
        togglePackaged={togglePackaged}
        actions={itemActions}
      />
    );
  }

  if (props.item.MarketplaceStatus === 'AwaitingDispatch' || props.item.MarketplaceStatus === 'PendingRetry') {
    return (
      <MarketplaceActionsAwaitingDispatch
        markAsDispatched={toggleDispatch}
        actions={itemActions}
        item={props.item}
        size={props.size}
        packaged={packaged}
        togglePackaged={togglePackaged}
      />
    );
  }

  return null;
}
